module.exports = __webpack_public_path__ + "img/research_eryuan.4e939b6a.png";